import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ops-currency-switch',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ops-currency-switch.component.html',
  styleUrls: ['./ops-currency-switch.component.scss'],
})
export class OpsCurrencySwitchComponent {
  @Input() value: 'EUR' | 'USD' | 'JPY' = 'USD';
  @Output() valueChange = new EventEmitter<'EUR' | 'USD' | 'JPY'>();

  isSelected(currency: 'EUR' | 'USD' | 'JPY') {
    return this.value === currency;
  }
  select(currency: 'EUR' | 'USD' | 'JPY') {
    if (this.value !== currency) {
      this.value = currency;
      this.valueChange.emit(currency);
    }
  }
}
